export class IdentityProvider{
    _id:string;
    name:string;
    active:boolean;
    createBy:string;
    createdOn:Date;
}